import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full flex flex-wrap md:flex-wrap-reverse justify-between" }
const _hoisted_2 = { class: "w-full md:w-auto md:order-1" }
const _hoisted_3 = {
  key: 1,
  class: "h-20 w-32 bg-gray-50 rounded-md flex flex-wrap content-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center text-gray-400 text-sm" }, " Logo puudub ", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "w-full md:w-1/2 truncate space-y-2 mb-6" }
const _hoisted_7 = { class: "text-gray-900 text-base font-medium truncate" }
const _hoisted_8 = { class: "flex items-center space-x-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-auto text-green-800",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1",
      d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1",
      d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
    })
  ])
], -1)
const _hoisted_10 = { class: "flex items-center space-x-2 text-gray-500 text-sm truncate" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-auto text-gray-600",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1",
    d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.clinic?.logo)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "h-20 w-32 bg-contain bg-center bg-no-repeat rounded-md",
            style: _normalizeStyle({ 'background-image': `url(${_ctx.clinic?.logo})` })
          }, null, 4))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.clinic.name), 1),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", {
          class: _normalizeClass(["px-2 py-1 inline-flex text-green-800 text-xs font-medium rounded-full", _ctx.clinic.licenceLocation ? 'bg-green-100' : ''])
        }, _toDisplayString(_ctx.clinic.licenceLocation), 3)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", null, _toDisplayString(_ctx.clinic.radiationPracticeLicenseHolder), 1)
      ])
    ])
  ]))
}